import React from 'react'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons'

import DateFormat from '../../utils/dateFormat'
import { ButtonLink } from '../../utils/Button'

const Matches = () => {
  const matches = useSelector(store => store.availabilityMatches.matches)
  const fetching = useSelector(store => store.availabilityMatches.fetching)

  if (fetching) {
    return (
      <div className="mt-12">
        <div className="flex mb-6">
          <FontAwesomeIcon icon={faCalendarCheck} className="self-center text-2xl sm:text-4xl text-gray-500" />
          <div className="ml-4">
            <h2 className="text-3xl font-semibold">Loading Matches</h2>
            <h5 className="text-md text-gray-500">{' '}</h5>
          </div>
        </div>
      </div>
    )
  }

  if (matches.length === 0) {
    return (
      <div className="mt-12">
        <div className="flex mb-6">
          <FontAwesomeIcon icon={faCalendarCheck} className="self-center text-2xl sm:text-4xl text-gray-500" />
          <div className="ml-4">
            <h2 className="text-3xl font-semibold">No matching availabilties</h2>
            <h5 className="text-md text-gray-500">{' '}</h5>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="mt-6">
      <div className="flex mb-6">
        <FontAwesomeIcon icon={faCalendarCheck} className="self-center text-2xl sm:text-4xl text-gray-500" />
        <div className="ml-4">
          <h2 className="text-lg">Availabilities</h2>
          <h5 className="text-md text-gray-500">{matches.length} still available</h5>
        </div>
      </div>

      <table className="w-full table-auto">
        <thead>
          <tr className="text-left bg-gray-100">
            <th>Arrive</th>
            <th>Max Nights</th>
            <th>Site #</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {matches.map(match => (
            <tr key={match.id} className="border-b border-grey-200">
              <td className="">
                <div className="mt-4 text-2xl font-semibold">
                  <DateFormat format="MM/DD" date={match.avail_date} />
                </div>
                <div className="mb-4 text-xl">
                  <DateFormat format="dddd" date={match.avail_date} />
                </div>
              </td>

              <td className="text-2xl font-semibold">{match.length}</td>
              <td className="">
                <div className="mt-4 text-2xl font-semibold">{match.site.site_num}</div>
                <div className="mb-4 text-xl">{match.site.loop}</div>
              </td>

              <td>
                <ButtonLink to={`/w/${match.short}`} color="green">
                  Reserve
                </ButtonLink>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Matches
